import { Utils } from '@Util/utils'

export type GridLocation = { row: number; col: number }

export enum DIRECTION {
  UP = 'UP',
  DOWN = 'DOWN',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

export class Grid {
  rows: number
  columns: number

  constructor(rows: number, columns: number) {
    this.rows = rows
    this.columns = columns
    this.isLocationInBounds.bind(this)
  }

  adjacentGridLocation(location: GridLocation): GridLocation[] {
    const adjacentLocations: GridLocation[] = [
      {
        row: location.row + 1,
        col: location.col,
      },
      {
        row: location.row - 1,
        col: location.col,
      },
      {
        row: location.row,
        col: location.col + 1,
      },
      {
        row: location.row,
        col: location.col - 1,
      },
    ]

    return adjacentLocations.filter((loc) => this.isLocationInBounds(loc))
  }

  getRandomGridLocation(row?: number, col?: number): GridLocation {
    const rows =
      row !== undefined
        ? [row]
        : Array.from({ length: this.rows }, (_, i) => {
            return i
          })
    const cols = col !== undefined ? [col] : Array.from({ length: this.columns }, (_, i) => i)

    return {
      row: Utils.getRandomElementFromArray(rows),
      col: Utils.getRandomElementFromArray(cols),
    }
  }

  isLocationInBounds(loc: GridLocation): boolean {
    if (loc.row < 0) return false
    if (loc.row >= this.rows) return false
    if (loc.col < 0) return false
    if (loc.col >= this.columns) return false

    return true
  }

  mapGridLocationToIndex(location: GridLocation) {
    if (
      location.row >= 0 &&
      location.row < this.rows &&
      location.col >= 0 &&
      location.col < this.columns
    ) {
      return location.row * this.columns + location.col
    }

    return -1
  }

  mapIndexToGridLocation(index: number): GridLocation {
    if (index < 0 || index >= this.rows * this.columns) {
      return {
        row: -1,
        col: -1,
      }
    }

    return {
      row: Math.floor(index / this.columns),
      col: index % this.columns,
    }
  }
}
